import { styled } from '~/styled'

export const DialogFooter = styled('footer', {
  base: ['flex', 'justify-end', 'gap-3', 'pt-4']
})
